export default () => ({
  trigger: {
    name: 'recommended_accessories.show_energy_label',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'energy_label',
      },
    },
    nonInt: true,
  },
});
